import useSymbol from '@/hooks/use-symbol';
import { useMarketStore } from '@/store/use-markets-store';
import { EventType, MarketStatus } from '@/types';
import { sendEvent } from '@/utils/analytics';
import { abbrFromSym } from '@/utils/token-symbol';
import { bigIntToDecimalStr } from '@/utils/value-format';
import { useEffect } from 'react';
import { useStore } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

export default function MarketHandler() {
  const symbol = useSymbol();
  const { midPrice, priceDecimals, isHidden } = useStore(
    useMarketStore(symbol),
    useShallow((state) => ({
      midPrice: state.marketData.midPrice,
      priceDecimals: state.marketSpec.priceDecimals,
      isHidden: state.marketSpec.status === MarketStatus.HALT,
    })),
  );

  useEffect(() => {
    document.title = `${bigIntToDecimalStr(
      midPrice,
      priceDecimals,
    )} | ${abbrFromSym(symbol)} | Vest Markets`;
  }, [midPrice, priceDecimals, symbol]);

  useEffect(() => {
    localStorage.setItem('last-market', symbol);
  }, [symbol]);

  useEffect(() => {
    if (!isHidden) return;
    sendEvent(EventType.UNLISTED_MARKET_VIEWED, { symbol });
  }, [symbol, isHidden]);

  return <></>;
}
